var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-area" },
    [
      _c("MessageAreaHeader", {
        attrs: {
          mode: _vm.conversationMode,
          superMenuState: _vm.superMenuState,
          contact: _vm.contact,
        },
        on: {
          command: _vm.setMessage,
          modeChanged: _vm.modeChanged,
          updateSuperMenuState: _vm.updateSuperMenuState,
          usedSlashCommand: _vm.usedSlashCommand,
          send: _vm.sendTemplateMessage,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message-area-container" },
        [
          _c("InformationOverlay", {
            key: _vm.contact._id,
            attrs: {
              status: _vm.contactStatus,
              contact: _vm.contact,
              isActiveUser: _vm.isActiveUser,
            },
            on: {
              focusEditor: _vm.focusEditor,
              blurEditor: _vm.blurEditor,
              "send-template-message": _vm.triggerTemplateMessage,
            },
          }),
          _vm._v(" "),
          _vm.conversationMode === "email"
            ? _c("MailSubject", {
                model: {
                  value: _vm.mailSubject,
                  callback: function ($$v) {
                    _vm.mailSubject = $$v
                  },
                  expression: "mailSubject",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.conversationMode === "sms"
            ? _c("SMSInput", {
                attrs: { value: _vm.smsInput },
                on: {
                  input: function (input) {
                    return (_vm.smsInput = input)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ChatEditor", {
            ref: "editor",
            attrs: {
              "file-send": !["sms", "email"].includes(_vm.conversationMode),
              "is-text": _vm.conversationMode === "sms",
              "enabled-banned-words": true,
              "emoji-picker": true,
              "speech-recognition": true,
              "share-voice": _vm.shareVoiceEnabled(),
              "share-location": _vm.shareLocationEnabled(),
              "share-attachment": true,
              placeholder: _vm.generateChatSuggestions(),
              editable: !_vm.contactStatus,
              "accepted-files": _vm.getAcceptedFiles(),
            },
            on: {
              "ai-tools": _vm.changeWithAI,
              updateSuperMenuState: _vm.updateSuperMenuState,
              submit: _vm.submitForm,
              location: _vm.sendLocation,
              "voice-message": _vm.sendVoiceMessage,
              "media-message": function ($event) {
                return _vm.$emit("media-message", $event)
              },
              "upload-file": function ($event) {
                return _vm.$emit("upload-file")
              },
            },
            model: {
              value: _vm.message,
              callback: function ($$v) {
                _vm.message = $$v
              },
              expression: "message",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }